import {
  KNM_APPROVE_INFO,
  KNM_CANCELLATION_INFO,
  KNM_CHECK_SHEETS,
  KNM_CONTROL_AGENCY,
  KNM_DOCUMENTS,
  KNM_EXECUTION_HISTORY,
  KNM_HISTORY,
  KNM_INFO,
  KNM_LAWSUITS,
  KNM_LINKS,
  KNM_NOTICE_INFO,
  KNM_PREVIOUS,
  KNM_REQUIREMENTS,
  KNM_RESULTS,
  KNM_SIGN_INFO,
  KNM_VERIFIED_PERSON,
  KNM_VIOLATIONS_LIST,
} from 'CorePackage/MainModule/routes/routes';

import { MenuItemsIdsEnum } from '../enums/MenuItemsIdsEnum';
import { IKnmMenuItem } from '../interfaces/IKnmMenuItem';

export const basicMenuItems: IKnmMenuItem[] = [
  {
    id: MenuItemsIdsEnum.KNM_INFO,
    route: `#${KNM_INFO}`,
    title: 'Общая информация',
  },
  {
    id: MenuItemsIdsEnum.KNM_REQUIREMENTS,
    route: `#${KNM_REQUIREMENTS}`,
    title: 'Обязательные требования',
  },
  {
    id: MenuItemsIdsEnum.KNM_CHECK_SHEETS,
    route: `#${KNM_CHECK_SHEETS}`,
    title: 'Проверочные листы',
  },
  {
    id: MenuItemsIdsEnum.KNM_APPROVE_INFO,
    route: `#${KNM_APPROVE_INFO}`,
    title: 'Сведения о согласовании',
  },
  {
    id: MenuItemsIdsEnum.KNM_CONTROL_AGENCY,
    route: `#${KNM_CONTROL_AGENCY}`,
    title: 'Информация об органе контроля',
  },
  {
    id: MenuItemsIdsEnum.KNM_VERIFIED_PERSON,
    route: `#${KNM_VERIFIED_PERSON}`,
    title: 'Информация о проверяемом лице',
  },
  {
    id: MenuItemsIdsEnum.KNM_NOTICE_INFO,
    route: `#${KNM_NOTICE_INFO}`,
    title: 'Информация об уведомлении',
  },
  {
    id: MenuItemsIdsEnum.KNM_RESULTS,
    route: `#${KNM_RESULTS}`,
    title: 'Результаты проверки',
  },
  {
    id: MenuItemsIdsEnum.KNM_VIOLATIONS_LIST,
    route: `#${KNM_VIOLATIONS_LIST}`,
    title: 'Выявленные нарушения',
  },
  {
    id: MenuItemsIdsEnum.KNM_LAWSUITS,
    route: `#${KNM_LAWSUITS}`,
    title: 'Меры, принятые по результатам',
  },
  {
    id: MenuItemsIdsEnum.KNM_CANCELLATION_INFO,
    route: `#${KNM_CANCELLATION_INFO}`,
    title: 'Сведения об отмене',
  },
  {
    id: MenuItemsIdsEnum.KNM_SIGN_INFO,
    route: `#${KNM_SIGN_INFO}`,
    title: 'Сведения о подписании',
  },
  {
    id: MenuItemsIdsEnum.KNM_DOCUMENTS,
    route: `#${KNM_DOCUMENTS}`,
    title: 'Документы',
  },
  {
    id: MenuItemsIdsEnum.KNM_PREVIOUS,
    route: `#${KNM_PREVIOUS}`,
    title: 'Предыдущие КНМ',
  },
  {
    id: MenuItemsIdsEnum.KNM_LINKS,
    route: `#${KNM_LINKS}`,
    title: 'Связанные КНМ',
  },
  {
    id: MenuItemsIdsEnum.KNM_HISTORY,
    route: `#${KNM_HISTORY}`,
    title: 'История изменений',
  },
  {
    id: MenuItemsIdsEnum.KNM_EXECUTION_HISTORY,
    route: `#${KNM_EXECUTION_HISTORY}`,
    title: 'История проведения КНМ',
  },
];
